// import Main from "@/components/main";
// import {

//   localRead
// } from "@/libs/util";
// // import parentView from '@/components/parent-view'

// /**
//  * iview-admin中meta除了原生参数外可配置的参数:
//  * meta: {
//  *  title: { String|Number|Function }
//  *         显示在侧边栏、面包屑和标签栏的文字
//  *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
//  *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
//  *  hideInBread: (false) 设为true后此级路由将不会出现在面包屑中，示例看QQ群路由配置
//  *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
//  *  notCache: (false) 设为true后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件name属性和路由配置的name一致
//  *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
//  *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
//  *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
//  * }
//  */
// import Auth from "@/router/modules/auth";
// import Storage from "@/router/modules/storage";
// import System from "@/router/modules/system";
// import Finance from "@/router/modules/finance";
// import Tracker from "@/router/modules/tracker";
// import User from "@/router/modules/user";
// import Bag from "@/router/modules/bag";
// import Packing from "@/router/modules/packing";
// import Order from "@/router/modules/order";
// import SouQ from "@/router/modules/souq";
// import DoubleClear from "@/router/modules/double";
// console.log(localRead)
// export default [
//   {
//     path: "/",
//     name: "_home",
//     redirect: "/home",
//     component: Main,
//     meta: {
//       hideInMenu: true,
//       notCache: true
//     },
//     children: [
//       {
//         path: "/home",
//         name: "home",
//         meta: {
//           hideInMenu: true,
//           title: "首页",
//           notCache: true,
//           icon: "md-home"
//         },
//         component: () => import("@/view/single-page/home")
//       }
//     ]
//   },
//   Auth,
//   Storage,
//   System,
//   Finance,
//   Tracker,
//   User,
//   Bag,
//   Packing,
//   Order,
//   // SouQ,
//   DoubleClear,
//   {
//     path: "/401",
//     name: "error_401",
//     meta: {
//       hideInMenu: true
//     },
//     component: () => import("@/view/error-page/401.vue")
//   },
//   {
//     path: "/500",
//     name: "error_500",
//     meta: {
//       hideInMenu: true
//     },
//     component: () => import("@/view/error-page/500.vue")
//   },
//   {
//     path: "*",
//     name: "error_404",
//     meta: {
//       hideInMenu: true
//     },
//     component: () => import("@/view/error-page/404.vue")
//   }
// ];

import Main from "@/components/main";
import { loadMenu } from "@/libs/router-util"; // ①添 引入加载菜单

/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  hideInBread: (false) 设为true后此级路由将不会出现在面包屑中，示例看QQ群路由配置
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件name属性和路由配置的name一致
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */
// 不作为Main组件的子页面展示的页面单独写
export const otherRouter = [
  {
    path: "/401",
    name: "error_401",
    meta: {
      hideInMenu: true
    },
    component: () => import("@/view/error-page/401.vue")
  },
  {
    path: "/500",
    meta: {
      title: "500-服务端错误"
    },
    name: "error_500",
    component: () => import("@/view/error-page/500.vue")
  }
];

// 作为Main组件的子页面展示但是不在左侧菜单显示的路由写在mainRouter里
export const mainRouter = [
  {
    path: "/login",
    name: "login",
    meta: {
      title: "Login - 登录",
      hideInMenu: true
    },
    component: () => import("@/view/login/login.vue")
  },
  {
    path: "/",
    name: "_home",
    redirect: "/home",
    component: Main,
    meta: {
      hideInMenu: true,
      notCache: true
    },
    children: [
      {
        path: "/home",
        name: "home",
        meta: {
          hideInMenu: true,
          title: "首页",
          notCache: true,
          icon: "md-home"
        },
        component: () => import("@/view/single-page/home")
      }
    ]
  }
];

// 作为Main组件的子页面展示并且在左侧菜单显示的路由写在appRouter里
export const appRouter = [...loadMenu()];

export const routes = [...mainRouter, ...otherRouter];
// 所有上面定义的路由都要写在下面输出
export default routes;
